<section class="m-3 rounded-xl border border-slate-300 bg-white p-4 text-slate-800 shadow-sm" aria-label="Hindsight 設定">
  <h2 class="mb-2 text-xl font-semibold">RAG（Hindsight）設定</h2>
  <p class="mb-4 text-sm text-slate-600">設定儲存在目前瀏覽器，供 Hindsight 查詢共用。Bank 使用後端設定。</p>
  <form (ngSubmit)="save()"><fieldset [disabled]="busy()" class="grid min-w-0 gap-3">
      <label class="grid gap-1">jk-api 網址
        <input class="w-full rounded border p-2" name="apiBaseUrl" [(ngModel)]="draft.apiBaseUrl" placeholder="http://localhost:8098" required>
      </label>
      <div class="flex flex-wrap items-end gap-3">
        <label class="grid gap-1">查詢模式
          <select class="rounded border p-2" name="mode" [(ngModel)]="draft.mode">
            <option value="recall">Recall — 記憶檢索</option><option value="reflect">Reflect — 生成回答</option>
          </select>
        </label>
        <label class="grid gap-1">搜尋預算
          <select class="rounded border p-2" name="budget" [(ngModel)]="draft.budget">
            <option value="low">low</option><option value="mid">mid</option><option value="high">high</option>
          </select>
        </label>
        <label class="grid gap-1">max_tokens
          <input class="w-32 rounded border p-2" type="number" name="maxTokens" [(ngModel)]="draft.maxTokens" min="1" step="1" required>
        </label>
      </div>
      <div class="flex flex-wrap gap-3">
        <label class="grid flex-1 gap-1">標籤（選填，以逗號分隔）
          <input class="min-w-0 rounded border p-2" name="tags" [(ngModel)]="draft.tags" placeholder="product:a, manual">
        </label>
        <label class="grid gap-1">標籤比對
          <select class="rounded border p-2" name="tagsMatch" [(ngModel)]="draft.tagsMatch">
            <option value="any">any</option><option value="all">all</option>
            <option value="any_strict">any_strict</option><option value="all_strict">all_strict</option><option value="exact">exact</option>
          </select>
        </label>
      </div>
    <div class="flex gap-2"><button class="btn-primary" type="submit">儲存設定</button>
      <button class="btn-secondary" type="button" (click)="checkHealth()">健康檢查</button></div>
  </fieldset></form>
  <div aria-live="polite" class="mt-3">
    @if (busy()) { <p role="status">處理中，請稍候…</p> }
    @if (message()) { <p class="text-green-700">{{ message() }}</p> }
    @if (error()) { <p role="alert" class="text-red-700">{{ error() }}</p> }
  </div>
  @if (details() !== null) { <details><summary>錯誤詳細資料</summary><pre class="overflow-auto whitespace-pre-wrap">{{ details() | json }}</pre></details> }
</section>
